export default __webpack_public_path__ + "static/media/om.6bfbee42.svg";